<template>

  <div  class="pedido my-4">
    <v-container class="my-2  font-weight-medium" >

       <v-row>

          <v-col lg="6" offset-lg="3" md="8" offset-md="2" sm="8" offset-sm="2" cols="12">
            <h1 :class="`${classTitle2}  font-weight-bold mb-4`">Entregas seguras y a tiempo</h1>
          </v-col>

          <v-col cols="12">
              <v-img contain
                  lazy-src="../assets/rastreo.jpg"
                  max-height="250"
                  src="../assets/rastreo.jpg"
              ></v-img>
          </v-col>

          <v-col lg="6" offset-lg="3" md="8" offset-md="2" sm="8" offset-sm="2" cols="12">
            
            <h1 :class="`${classTitle2} font-weight-bold my-4`">Rastrea tu pedido - Sinaloa</h1>
            <pedido-form></pedido-form>
            <div class="pt-8"> <a :href="this.urlImage" target="_blank" style="text-decoration: none;">
              <p class="text-center red--text text--darken-2 font-weight-bold subtitle-2">¿Donde encuentro mi folio de factura?</p>
            </a></div>
            
          </v-col>

          
          <v-col lg="6" offset-lg="3" md="8" offset-md="2" sm="8" offset-sm="2" cols="12" :class="this.$vuetify.breakpoint.name == 'xs'? 'px-6':''">
            <v-divider></v-divider>

            <!--  
            <h1 :class="`${classTitle} font-weight-bold my-4`">Compras en tienda física</h1>
            <p :class="`${classParagraph}`">
              Si tu compra la realizaste en alguno de nuestros puntos de venta físicos, en este apartado puedes monitorear el status de tu pedido; solo introduce en el buscador el folio de la factura en la zona que indica la imagen “¿Dónde está mi folio?” y podrás saber cuándo recibirás tus compras. 
            </p>
              -->
          </v-col>
        

          <!--  
          <v-col lg="6" offset-lg="3" md="8" offset-md="2" sm="8" offset-sm="2" cols="12" :class="this.$vuetify.breakpoint.name == 'xs'? 'px-6':''">  
            <h1 :class="`${classTitle} font-weight-bold my-4`">Compras en Kuroda.com (Ciudad con cobertura física Kuroda)</h1>
            <p :class="`${classParagraph}`">
              Si tu compra la realizaste a través de nuestro sitio <a href="https://kuroda.com/" style="text-decoration: none;" class="red--text text--darken-2 font-weight-bold">Kuroda.com</a> y vives en una ciudad con cobertura de tienda física te haremos entrega de tus compras a través de nuestro equipo de distribución por lo que el rastreo lo puedes realizar con tu folio de factura en el buscador arriba mencionado. 
            </p>
          </v-col>
          -->

          <!--  
          <v-col  lg="6" offset-lg="3" md="8" offset-md="2" sm="8" offset-sm="2" cols="12" :class="this.$vuetify.breakpoint.name == 'xs'? 'px-6':''">  
            <h1 :class="`${classTitle} font-weight-bold my-4`">Compras en Kuroda.com (Ciudad sin cobertura física Kuroda)</h1>
            <p :class="`${classParagraph}`">
              <span>Si las compras que realizaste en nuestro sitio y si en tu ciudad de origen o de entrega de la mercancía no cuenta con punto de venta físico el envío de los productos serán a través de un servicio externo de paquetería externo por lo que indicaremos el número de guía para que puedas dar el seguimiento a tu pedido.</span>
              <br><br>
              <span>En cualquiera de los casos se les mantendrá informados desde que realicen la compra hasta que hayan recibido satisfactoriamente sus compras. </span>
              <br><br>
              <span>Cualquier duda o comentario se pueden dirigir a nuestras variadas formas de contacto. </span>
            </p>
          </v-col>
          -->
         

       </v-row>
    </v-container>
   
  </div>
</template>

<script>
  
  //COMPONENTS
  import Form      from '../components/Form.vue'

  export default {
    name: 'Home',
    components: {
      'pedido-form' : Form,
    },
    data() {
      return {
        //urlImage: 'https://cdn.shopify.com/s/files/1/0056/1361/7186/files/Folio_de_factura_para_rastrear_pedido.png?2981'
        urlImage: 'https://rastreo.kuroda.com/Folio_de_factura_para_rastrear_pedido.png'
      } 
    },
    computed: {
      classParagraph() {
          switch (this.$vuetify.breakpoint.name) {
          case 'xs': return 'text-justify subtitle-2'
          case 'sm': return 'text-justify subtitle-1'
          case 'md': return 'text-justify subtitle-1'
          case 'lg': return 'text-justify subtitle-1;'
          case 'xl': return 'text-justify subtitle-1;'
          }
      },
      classTitle() {
          switch (this.$vuetify.breakpoint.name) {
          case 'xs': return 'text-center body-1'
          case 'sm': return 'text-center title'
          case 'md': return 'text-left headline'
          case 'lg': return 'text-left headline'
          case 'xl': return 'text-left headline'
          }
      },
      classTitle2() {
          switch (this.$vuetify.breakpoint.name) {
          case 'xs': return 'text-center body-1'
          case 'sm': return 'text-center title'
          case 'md': return 'text-center headline'
          case 'lg': return 'text-center headline'
          case 'xl': return 'text-center headline'
          }
      },
    }
  }
</script>
